import axios from 'axios'
import Qs from 'qs'
import {hex_md5} from '../common/md5'

// let routerMode = 'hash'
export const apiUrl = 'http://api.dh.kxp1688.com'

const timeout = '';
const withCredentials = true;


function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]); return "";
}
let h5_token = GetQueryString('h5_token');


// alert(h5_token)


//返回状态判断
axios.interceptors.response.use((res) => {
  if (!res.data.success) {
    return Promise.resolve(res);
  }
  return res;
}, (error) => {
  return Promise.reject(error);
});


let str = 'a=1&b=2'  //设置签名
//post请求
const post = (url, params, type) => {
  type === "qs" && (params = Qs.stringify(params))
  type === "json" && (params = JSON.stringify(params))

  let sign = hex_md5(str);
  let time =  new Date().getTime();

  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: url+'?' + str,
      baseURL: apiUrl,
      timeout: timeout,
      withCredentials: true,
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'nonce_str':time,
        'sign':sign,
        'accessToken':h5_token
      }
    }).then(response => {
      // if(data.authStatus !== 'Y') { //token失效
      //   //需要告诉app重新登录
      //   return;
      // }
      resolve(response.data);
    }, err => {
      reject(err);
    })
      .catch((error) => {
        reject(error)
      })
  })
}



//get请求
const get = (url, params = '') => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: url,
      baseURL: apiUrl,
      timeout: timeout,
      withCredentials: withCredentials,
      params: params,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        
      }
    }).then(response => {
      resolve(response.data);
    }, err => {
      reject(err);
    })
      .catch((error) => {
        reject(error)
      })
  })
}


export const api = {
  //获取订单列表
  queryOrder:(data) => post('/api/kxdh/merchant/v1/order/queryOrder.do','json'),
  //获取订单详情
  getOrderDetail:(data) => post('/api/kxdh/merchant/v1/order/getOrderDetail.do',data,'json'),
  //作废订单
  cancelOrder:(data) => post('/api/kxdh/merchant/v1/order/cancelOrder.do',data,'json'),
  //删除订单
  removeOrder:(data) => post('/api/kxdh/merchant/v1/order/removeOrder.do',data,'json'),
  //付款记录
  getPaymentInfo:(data) => post('/api/kxdh/merchant/v1/orderPayment/getOrderPaymentInfo.do',data,'json'),
  //筛选状态
  getOrderStatus:(data) => post('/api/kxdh/merchant/v1/public/ajax/getEnumListByName.do',data,'json'),
  //出库/发货记录
  getShippedList:(data) => post('/api/kxdh/merchant/v1/order/getShippedList.do',data,'json'),
  //待发货数量
  getDelivery:(data) => post('/api/kxdh/merchant/v1/order/getDelivery.do',data,'json'),
  //添加备注
  addRemark:(data) => post('/api/kxdh/merchant/v1/order/addRemark.do',data,'json'),
  //删除附件
  deleteFile:(data) => post('/api/kxdh/file/upload/deleteFile.do',data,'json'),
  //确认签收
  shippingReceived:(data) => post('/api/kxdh/merchant/v1/order/shippingReceived.do',data,'json'),




  //购物车列表
  queryShopCartList:(data) => post('/h5/kxdh/shopcart/queryShopCartList.do',data,'json'),
} 




// WEBPACK FOOTER //
// ./src/api/api.js